import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly defaultColor = '#9EC600';

  constructor(private snackBar: MatSnackBar) { }

  info(message: string, title?: string): void {
    this.show(message, title, 'info');
  }

  success(message: string, title?: string): void {
    this.show(message, title, 'success');
  }

  warning(message: string, title?: string): void {
    this.show(message, title, 'warn');
  }

  error(message: string, title?: string): void {
    this.show(message, title, 'error', null, 8000);
  }

  show(message: string, title: string, type: string, backgroundColor?: string, hideAfter?: number): void {
    this.snackBar.open(message, '', {
      duration: 3000,
      panelClass: 'brand-valid'
    });
  }
}
